import { StateCreator } from 'zustand';

import { FileUploadData, ImportEmployeesSlice } from './types';

const initialState: FileUploadData = {
  fileType: undefined,
  payCalendarId: '',
  payCalendarName: '',
  bulkImportId: '',
  bulkImportStatus: undefined,
  fileUploadId: '',
  uploadType: undefined,
  analysisData: undefined,
  edfAnalysisData: undefined,
  elfAnalysisData: undefined,
  leaveModalSource: undefined,
};

// Legacy implementation for backward compatibility
const importEmployeesSlice: StateCreator<ImportEmployeesSlice> = (set) => ({
  // File upload data (new structure)
  fileUploadData: initialState,
  setFileUploadData(fileUploadData) {
    set((state) => ({
      fileUploadData: { ...state.fileUploadData, ...fileUploadData },
    }));
  },

  resetFileUploadData() {
    set({ fileUploadData: initialState });
  },

  // Legacy interface (backward compatibility)
  importEmployeesData: initialState,
  setImportEmployeesData(importEmployeesData) {
    set((state) => ({
      fileUploadData: { ...state.fileUploadData, ...importEmployeesData },
      importEmployeesData: { ...state.fileUploadData, ...importEmployeesData },
    }));
  },

  resetImportEmployeesData() {
    set({
      fileUploadData: initialState,
      importEmployeesData: initialState,
    });
  },
});

export default importEmployeesSlice;
